import React from 'react'
import { Link } from 'react-router-dom'
import {
  NotGroupedContainer,
  GroupHeaderContainer,
  GroupHeaderFirstLine,
  GroupNameDisplay,
  GroupHeaderStudentNames,
  NotGroupedMessage,
} from './styled'

const NotGroupedSection = ({ notGroupedStudents }) => {
  const studentNamesStr =
    (notGroupedStudents || [])
      .map((s) => s.name || s.studentName || '')
      .filter(Boolean)
      .join(', ') || '—'
  return (
    <NotGroupedContainer>
      <GroupHeaderContainer style={{ cursor: 'default', paddingRight: 0 }}>
        <GroupHeaderFirstLine>
          <GroupNameDisplay style={{ cursor: 'default' }}>
            <b>Not Grouped</b>
          </GroupNameDisplay>
        </GroupHeaderFirstLine>
        {studentNamesStr && studentNamesStr !== '—' && (
          <GroupHeaderStudentNames>{studentNamesStr}</GroupHeaderStudentNames>
        )}
      </GroupHeaderContainer>
      <NotGroupedMessage>
        Not enough data to determine mastery yet. View the{' '}
        <Link to="/author/reports/standards-performance-summary">
          Standards mastery report
        </Link>{' '}
        for more details.
      </NotGroupedMessage>
    </NotGroupedContainer>
  )
}

export default NotGroupedSection
